"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProfileEventCallbacks = createProfileEventCallbacks;
function createProfileEventCallbacks(contextRef) {
    return {
        community_member_profile_followed: function (targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_profile_followed', __assign({ context: 'community' }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_member_profile_unfollowed: function (targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_profile_unfollowed', __assign({ context: 'community' }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_member_profile_viewed: function (isLoggedIn, targetDisplayName, viewerIsFollowing) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_profile_viewed', __assign(__assign({ context: 'community', is_logged_in: isLoggedIn }, (targetDisplayName && { target_display_name: targetDisplayName })), (viewerIsFollowing != null && { viewer_is_following: viewerIsFollowing })));
        },
        community_member_connections_viewed: function (tab, targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_connections_viewed', __assign({ context: 'community', tab: tab }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_member_connection_modal_followed: function (targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_connection_modal_followed', __assign({ context: 'community' }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_member_connection_modal_unfollowed: function (targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_member_connection_modal_unfollowed', __assign({ context: 'community' }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_profile_shared: function (method, targetDisplayName) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_profile_shared', __assign({ context: 'community', method: method }, (targetDisplayName && { target_display_name: targetDisplayName })));
        },
        community_profile_edited: function () {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_profile_edited', {
                context: 'community',
            });
        },
        community_profile_created: function (hasBio, hasAvatar, visibility, archetype, profileCompleteness) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_profile_created', __assign(__assign({ context: 'community', has_bio: hasBio, has_avatar: hasAvatar, visibility: visibility }, (archetype && { archetype: archetype })), (profileCompleteness != null && { profile_completeness: profileCompleteness })));
        },
        community_connections_viewed: function (tab) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('community_connections_viewed', {
                context: 'community',
                tab: tab,
            });
        },
    };
}
